import angular from 'angular';
import 'angular-ui-router';
import {map} from 'lodash';
import template from './gamesForm.jade';
import {appStoreField, appStoreFieldText, isNumberValidator} from '../admin/games/gamesForm';
import { isDomain } from '../../common/util/validation-util.js';

export class GamesFormController {
  /* @ngInject */
  constructor($filter, genresOptions,platformsOptions, iabCategoriesOptions, currentUser){
    this.translate = $filter('translate');
    this.currentUser = currentUser;
    this.fields = [
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'name',
        expressionProperties: {
          "templateOptions.label": "'name' | translate"
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'genres',
        type: 'uiSelectMultiple',
        templateOptions: {
          label: this.translate('genres') + " (" + this.translate('up_to') + " 5)",
          options: genresOptions,
          required: true,
          limit: 5
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'iab_categories',
        type: 'uiSelectMultiple',
        templateOptions: {
          label: `${this.translate('iab_categories')}`,
          options: iabCategoriesOptions,
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'platforms',
        type: 'checkbuttonMultiple',
        expressionProperties: {
          "templateOptions.label": "'platforms' | translate"
        },
        templateOptions: {
          label: '',
          options: platformsOptions,
          required: true
        }
      },
      {
        className: 'layout__item u-12/12',
        type: 'input',
        key: 'domain',
        expressionProperties: {
          "templateOptions.label": "'domain' | translate"
        },
        templateOptions: {
          label: '',
          type: 'text',
          help: this.translate('game_domain_help'),
          helpTextPlacement: 'right'
        },
        validators: {
          domain: isDomain
        }
      },
      appStoreFieldText('Android','android_bundle_id'),
      appStoreField('Android','url_android_app_store'),
      appStoreFieldText('iOS','ios_bundle_id', isNumberValidator),
      appStoreField('iOS','url_apple_app_store'),
      appStoreField('WindowsPhone','url_windows_app_store', 12),
      //appStoreField('Desktop','url_web'),
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'external_id',
        expressionProperties: {
          "templateOptions.label": "'external_id' | translate"
        },
        templateOptions: {
          label: '',
          required: false
        }
      }
    ]

    this.fields = map(this.fields, ({className, ...rest}) => ({
      className: this.withDisabledClassName(className),
      ...rest
    }))
  }

  withDisabledClassName(className) {
    return this.currentUser.value.hasRole(['AGENCY','GD_ACCOUNT_MANAGER','GG_ACCOUNT_MANAGER']) ? `${className} disabled-by-role` : className;
  };
}

export function GamesFormComponent() {
  return {
    template,
    controller: GamesFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '=',
      logo: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.games.form', [])
  .directive('gamesForm', GamesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/gamesForm.js
 **/